export const inlineOptions = {
    toolbar: false,
    smallBtn: true,
    trapFocus: false,
    touch: false,
    clickOutside: false,
    clickSlide: false,
    btnTpl: {
        arrowLeft: `
        <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
            <i class="icon-arrow-left"></i>
        </button>
        `,
        arrowRight: `
        <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
            <i class="icon-arrow-right"></i>
        </button>
        `,
        smallBtn: `
        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
            <i class="icon-close"></i>
        </button>
        `,
    },
    thumbs: {
        autoStart: true, // Display thumbnails on opening
        hideOnClose: true, // Hide thumbnail grid when closing animation starts
        parentEl: ".fancybox-container", // Container is injected into this element
        axis: "x" // Vertical (y) or horizontal (x) scrolling
    },
    // beforeLoad: function (instance, slide) {
    //     if (slide.$slide[0].attributes["data-fancybox-class"]) {
    //         $(instance.$refs.container[0]).addClass(
    //             instance.$lastFocus[0].attributes["data-fancybox-class"].value
    //         );
    //     }
    // },
    // afterClose: function () {
    //     try {
    //         $scope.responses.registerForm.success = false;
    //     } catch (e) {

    //     }
    // }
}

export const galleryOptions = {
    infobar: false,
    smallBtn: true,
    toolbar: false,
    protect: false,
    clickOutside: false,
    clickSlide: false,
    touch: false,
    image: {
        preload: true
    },
    animationEffect: "fade", //zoom-in-out, fade
    spinnerTpl: '<div class="fancybox-loading"></div>',
    transitionEffect: "slide",
    btnTpl: {
        arrowLeft: `
        <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
            <i class="icon-arrow-left"></i>
        </button>
        `,
        arrowRight: `
        <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
            <i class="icon-arrow-right"></i>
        </button>
        `,
        smallBtn: `
        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
            <i class="icon-close"></i>
        </button>
        `,
    },
    // thumbs: {
    //     autoStart: true, // Display thumbnails on opening
    //     hideOnClose: true, // Hide thumbnail grid when closing animation starts
    //     parentEl: ".fancybox-container", // Container is injected into this element
    //     axis: "x" // Vertical (y) or horizontal (x) scrolling
    // },
}

export const collectionOptions = {
    idleTime: 30,
    infobar: false,
    smallBtn: true,
    toolbar: false,
    protect: false,
    clickSlide: false,
    image: {
        preload: true
    },
    animationEffect: "fade", //zoom-in-out, fade
    spinnerTpl: '<div class="fancybox-loading"></div>',
    transitionEffect: "slide",
    btnTpl: {
        arrowLeft: `
        <button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">
            <i class="icon-arrow-left"></i>
        </button>
        `,
        arrowRight: `
        <button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">
            <i class="icon-arrow-right"></i>
        </button>
        `,
        smallBtn: `
        <button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">
            <i class="icon-close"></i>
        </button>
        `,
    },
    // thumbs: {
    //     autoStart: true, // Display thumbnails on opening
    //     hideOnClose: true, // Hide thumbnail grid when closing animation starts
    //     parentEl: ".fancybox-container", // Container is injected into this element
    //     axis: "x" // Vertical (y) or horizontal (x) scrolling
    // },
}

export default inlineOptions;